import React, { useEffect, useState } from "react"
import clsx from "clsx"
import HeaderPopup from "@components/header/components/popover/HeaderPopup"
import { container, LoadingBox } from "@components/wrapper"
import { LinkHead } from "../HeaderComponent"
import { useProgramSections } from "@lib/hooks/data/useProgramSections"

export const ServiceDropdown = ({ transparent }: { transparent?: boolean }) => {
  const { visibleSections: visibleTabs, isLoading, showProgramNav } = useProgramSections()
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (activeIndex >= visibleTabs.length) {
      setActiveIndex(0)
    }
  }, [activeIndex, visibleTabs.length])

  if (!showProgramNav) {
    return null
  }

  const activeTab = visibleTabs[activeIndex]

  const PopoverComponent = () => {
    if (isLoading) {
      return (
        <div className={clsx(container, "grid gap-5")}>
          <LoadingBox height="h-[200px]" />
        </div>
      )
    }

    if (!activeTab) {
      return null
    }

    return (
      <div className={clsx(container, "grid gap-5")}>
        <div className="flex gap-8 text-md font-medium ">
          {visibleTabs.map((tab, index) => (
            <div
              className={clsx(
                index === activeIndex && "text-blue border-b-2 pb-2 border-blue",
                "text-black",
                "cursor-pointer"
              )}
              onClick={() => setActiveIndex(index)}
              key={tab.key}
            >
              {tab.title}
            </div>
          ))}
        </div>
        <div className="flex gap-6 items-center">
          <div className="w-max text-2xl font-bold text-black-22 font-urbanist">{activeTab.title}</div>
          <div className="w-max text-black-22">{activeTab.description}</div>
        </div>

        <div className="flex gap-12">
          <div className="grid w-full auto-rows-auto grid-cols-3 items-start gap-4 text-black">
            {activeTab.items.map((item) => (
              <LinkHead key={item.slug} link={activeTab.buildLink(item.slug)}>
                {item.name}
              </LinkHead>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <HeaderPopup
      menuKey="service"
      panel={<PopoverComponent />}
      buttonLabel="Program"
      transparent={transparent}
    />
  )
}
